import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
    estimated: boolean;
};

export const GradeScatterChartKey = (props: Props) => {
    const { estimated } = props;

    const { t } = useTranslation("common");

    return (
        <div className="col-12 lg:col-4">
            <div className="grade-key-container">
                <small className="grade-key-header">
                    {`${t("inspectionReport.gradeComparison.key")}`}
                </small>
                <div className="flex justify-content-between">
                    <div>
                        <small className="grade-key-info">
                            {`${t(
                                estimated
                                    ? "inspectionReport.gradeComparison.estimatedIdwalGrade"
                                    : "inspectionReport.gradeComparison.yourIdwalGrade"
                            )}`}
                        </small>
                        <div>
                            {estimated ? (
                                <svg
                                    className="grade-key-circle"
                                    width="50"
                                    height="21"
                                    viewBox="0 0 50 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        y="0.549561"
                                        width="50"
                                        height="20"
                                        rx="10"
                                        fill="#28235B"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    className="grade-key-circle"
                                    width="50"
                                    height="21"
                                    viewBox="0 0 50 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        y="0.5"
                                        width="20"
                                        height="20"
                                        rx="10"
                                        fill="#28235B"
                                    />
                                </svg>
                            )}
                        </div>
                    </div>
                    <div>
                        <small className="grade-key-info">
                            {`${t(
                                "inspectionReport.gradeComparison.averageIdwalGrade"
                            )}`}
                        </small>
                        <div>
                            <svg
                                className="grade-key-dash"
                                width="50"
                                height="21"
                                viewBox="0 0 50 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10 12.0176L1.74846e-07 12.0176L0 10.0176L10 10.0176L10 12.0176Z"
                                    fill="#28235B"
                                />
                                <path
                                    d="M30 12.0176L20 12.0176L20 10.0176L30 10.0176L30 12.0176Z"
                                    fill="#28235B"
                                />
                                <path
                                    d="M50 12.0176L40 12.0176L40 10.0176L50 10.0176L50 12.0176Z"
                                    fill="#28235B"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-between">
                    <div>
                        <small className="grade-key-info">
                            {`${t(
                                "inspectionReport.gradeComparison.allSectorShips"
                            )}`}
                        </small>
                        <div>
                            <svg
                                className="grade-key-circle"
                                width="50"
                                height="21"
                                viewBox="0 0 50 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20 10.5C20 12.4778 19.4135 14.4112 18.3147 16.0557C17.2159 17.7002 15.6541 18.982 13.8269 19.7388C11.9996 20.4957 9.98891 20.6937 8.0491 20.3079C6.10928 19.922 4.32746 18.9696 2.92893 17.5711C1.53041 16.1726 0.578006 14.3908 0.192154 12.4509C-0.193699 10.5111 0.00432818 8.50045 0.761205 6.67319C1.51808 4.84592 2.79978 3.28412 4.44427 2.1853C6.08877 1.08649 8.02217 0.5 9.99999 0.5C12.6522 0.5 15.1957 1.55359 17.0711 3.42896C18.9464 5.30433 20 7.84785 20 10.5Z"
                                    fill="#BBBFC3"
                                />
                            </svg>
                        </div>
                    </div>
                    <div>
                        <small className="grade-key-info">
                            {`${t(
                                "inspectionReport.gradeComparison.ageComparableShips"
                            )}`}
                        </small>
                        <div>
                            <svg
                                className="grade-key-circle"
                                width="50"
                                height="21"
                                viewBox="0 0 50 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M20 10.5C20 12.4778 19.4135 14.4112 18.3147 16.0557C17.2159 17.7002 15.6541 18.982 13.8269 19.7388C11.9996 20.4957 9.98891 20.6937 8.0491 20.3079C6.10928 19.922 4.32746 18.9696 2.92893 17.5711C1.53041 16.1726 0.578006 14.3908 0.192154 12.4509C-0.193699 10.5111 0.00432818 8.50045 0.761205 6.67319C1.51808 4.84592 2.79978 3.28412 4.44427 2.1853C6.08877 1.08649 8.02217 0.5 9.99999 0.5C12.6522 0.5 15.1957 1.55359 17.0711 3.42896C18.9464 5.30433 20 7.84785 20 10.5Z"
                                    fill="#00C7CC"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <p className="grade-info">
                {`${t("inspectionReport.gradeComparison.scatterChartKey")}`}
            </p>
        </div>
    );
};
